import {NodeLocationInfo} from 'Contexts/NodeCallBackContext';

export interface EdgesAndOffsets {
    offsetTop: number;
    offsetBottom: number;
    offsetLeft: number;
    offsetRight: number;
    leftEdgeOfSelectedNode: number;
    rightEdgeOfSelectedNode: number;
    topEdgeOfSelectedNode: number;
    bottomEdgeOfSelectedNode: number;
    selectedNodeTopEdge: number;
    selectedNodeBottomEdge: number;
    spaceBetweenBottomEdge: number;
    spaceBetweenRightEdge: number;
}

export const getEdgesAndOffsets = (
    xyLocation: () => NodeLocationInfo['actual'],
    location: () => NodeLocationInfo,
    rootLocation: () => NodeLocationInfo
): EdgesAndOffsets => {
    const locationInfo = location().actual;
    const rootLocationInfo = rootLocation().actual;
    const xy = xyLocation();

    const topEdge = locationInfo.y - rootLocationInfo.y;
    const bottomEdge = locationInfo.y - rootLocationInfo.y + locationInfo.height;

    const rootLeftOffset = rootLocationInfo.x - xy.x;
    const rootRightOffset = xy.x + xy.width - (rootLocationInfo.x + rootLocationInfo.width);
    const rootTopOffset = rootLocationInfo.y - xy.y;
    const rootBottomOffset = xy.y + xy.height - (rootLocationInfo.y + rootLocationInfo.height);

    const leftEdgeOfSelectedNode = locationInfo.x - rootLocationInfo.x;
    const rightEdgeOfSelectedNode = locationInfo.x - rootLocationInfo.x + locationInfo.width;

    const spaceBetweenBottomEdge =
        rootLocationInfo.y + rootLocationInfo.height - (locationInfo.height + locationInfo.y);
    const spaceBetweenRightEdge = rootLocationInfo.x + rootLocationInfo.width - (locationInfo.width + locationInfo.x);

    return {
        offsetLeft: rootLeftOffset,
        offsetRight: rootRightOffset,
        offsetTop: rootTopOffset,
        offsetBottom: rootBottomOffset,
        selectedNodeTopEdge: topEdge,
        selectedNodeBottomEdge: bottomEdge,
        leftEdgeOfSelectedNode,
        rightEdgeOfSelectedNode,
        topEdgeOfSelectedNode: topEdge,
        bottomEdgeOfSelectedNode: bottomEdge,
        spaceBetweenBottomEdge,
        spaceBetweenRightEdge,
    };
};
